<template>
  <div class="order">
    <Form class="search" inline :label-width="100" :show-message="false" label-position="left">
      <div class="status">
        <div class="label">订单状态:</div>
        <div class="tabNav">
          <div class="tab-item" :class="{active:statusId == item.value}" v-for="(item,index) in tabNav" :key="index"
            @click="changeStatus(item.value)">
            {{ item.label }}
            <span id="" class="text-red" v-if="item.order_number>0">
              ({{item.order_number}})
            </span>
          </div>
        </div>
        <!-- <tabNav :type="'order'" v-model="search.status" :values='statusId' :list="tabNav" @change='changeStatus'>
				</tabNav> -->
      </div>
      <searchFormItemInput label="师傅姓名" placeholder="师傅姓名" v-model="search.worker_nickname"></searchFormItemInput>
      <searchFormItemInput label="师傅手机号" placeholder="师傅手机号" v-model="search.worker_phone"></searchFormItemInput>
      <searchFormItemInput label="订单号" placeholder="订单号" v-model="search.order_no"></searchFormItemInput>
      <searchFormItemInput label="客户信息" placeholder="客户姓名、手机号" v-model="search.contacts"></searchFormItemInput>
      <searchFormItemSelect label="服务类目" @on-change='changeClass' :list="service" v-model="search.class_id">
      </searchFormItemSelect>
      <searchFormItemSelect label="服务类型" @on-change='changeType' :list="serviceList" v-model="search.type_id">
      </searchFormItemSelect>
      <div class="form-footer">
        <searchFormItemButton @on-click="searchOrder()"></searchFormItemButton>
        <div class="refresh-btn" @click="refreshOrder()">刷新列表</div>
        <searchFormItemClear @on-clear="clear()"></searchFormItemClear>
      </div>
    </Form>
    <div class="" v-loading="loading">
      <orderItem :order_no="item.number" :product_img="item.product_img" :contact="item.contact"
        :customer_name="getCustomerName(item)"
        :status_name="item.status_name" :created_at="item.created_at" :phone="item.phone" :address="item.address"
        :service_name="item.service_name" :product_class="item.product_class" :product_number="item.product_number"
        :order_type="item.order_type" :price="item.price" :show_offer="getShowOffer(item)" :status="item.status" :id="item.id"
        :fee_detail="item.fee_detail"
        :remark="item.remark || ''" :remark_list="item.remark_list || item.remarks || item.order_remarks || []"
        :remark_count="getRemarkCount(item)"
        :flag_color="item.flag_color || item.remark_color || item.color || ''"
        :has_worker_inscrease="item.has_worker_inscrease"
        :order_inscrease="item.order_inscrease"
        @refresh="getOrder"
        v-for="(item,i) in orderData" :key="i"></orderItem>
      <div v-if="!loading && loadError">{{loadErrorMessage}}，请点击“刷新列表”重试。</div>
      <el-empty :image-size="120" v-if="!loading && !loadError && orderData.length==0"></el-empty>
      <PageComponents :total="tableShow.listCount" :current="tableShow.currentPage" :pageSize="tableShow.pageSize"
        @on-change="changePage"></PageComponents>
    </div>

  </div>
</template>

<script>
import {
  EventBus
} from '@/utils/event-bus.js'
import tabNav from '../../../components/tabNav'
import {
  searchFormItemInput,
  searchFormItemSelect,
  searchFormItemButton,
  searchFormItemClear
} from '../../../components/search-form-item'
import orderItem from './components/order-item'
import PageComponents from '../../../components/page'

const ORDER_REMARK_LIST_API = '690000000002'

export default {
  name: 'order',
  components: {
    tabNav,
    searchFormItemInput,
    searchFormItemSelect,
    searchFormItemButton,
    searchFormItemClear,
    PageComponents,
    orderItem
  },
  data () {
    return {
      search: {
        status: '',
        worker_nickname: '',
        worker_phone: '',
        contacts: '',
        order_no: '',
        class_id: 0,
        type_id: 0
      },
      statusId: '0',
      orderData: [],
      service: [],
      serviceList: [],
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      formItem: {
        name: ''
      },
      loading: true,
      loadError: false,
      loadErrorMessage: '',
      remarkCache: {},
      orderRequestKey: 0,
      tabNav: []
    }
  },
  created () {
    let vm = this
  },
  activated () {
    let vm = this
    if (vm.$route.query.fromWorkbench === '1') {
      vm.search = {
        status: '',
        worker_nickname: '',
        worker_phone: '',
        contacts: '',
        order_no: '',
        class_id: 0,
        type_id: 0
      }
      vm.statusId = '0'
      vm.tableShow.currentPage = 1
    }
    const routeStatus = vm.$route.params.id
    if (routeStatus !== undefined && routeStatus !== null) {
      if (String(vm.statusId) !== String(routeStatus)) vm.tableShow.currentPage = 1
      vm.search.status = routeStatus
    }
    vm.statusId = vm.search.status === '' ? '0' : vm.search.status
    console.log(vm.$route.params, '====params===============')
    if (vm.$route.query.fromWorkbench === '1') {
      const query = Object.assign({}, vm.$route.query)
      delete query.fromWorkbench
      vm.$router.replace({ name: 'order_list', query, params: vm.$route.params })
    }
    vm.getStatus()
    vm.getOrder()
    // if(vm.$route.params.type){
    //   location.reload()
    // }
  },
  mounted () {
    // EventBus.$on("aMsgOrder", (msg) => {
    //   vm.getStatus()
    //   vm.getOrder()
    //   console.log('更新列表')
    // });
    let vm = this
  },
  destroyed () {
    console.log('destroyed页面销毁')
    // EventBus.$off("aMsgOrder")
  },
  methods: {
    getShowOffer (order) {
      const offer = Array.isArray(order.offer_info) ? order.offer_info[0] : null
      if (offer && offer.show_offer !== undefined && offer.show_offer !== null && offer.show_offer !== '') {
        return offer.show_offer
      }
      return 0
    },
    getCustomerName (order) {
      if (!order) return ''
      const address = order.address && typeof order.address === 'object' ? order.address : {}
      const names = [order.customer_name, address.name, order.name, order.contacts_name, order.customer]
      return names.find(name => typeof name === 'string' && name.trim()) || ''
    },
    async loadOrderDetails (orders, requestKey) {
      for (const order of orders) {
        if (requestKey !== this.orderRequestKey) return
        const needsFeeDetails = !Array.isArray(order.order_inscrease) &&
          (String(order.has_worker_inscrease) === '1' || order.has_worker_inscrease === true)
        if (!order.id || (this.getCustomerName(order) && !needsFeeDetails)) continue
        try {
          const res = await this.$request('6120ad9af2b9b', { order_id: order.id }, 'post', { silentError: true })
          if (requestKey !== this.orderRequestKey) return
          const detail = res && res.data && res.data.data
          const name = detail && detail.address && detail.address.name
          const item = this.orderData.find(item => item.id === order.id)
          if (!item) continue
          if (typeof name === 'string' && name.trim()) this.$set(item, 'customer_name', name.trim())
          if (detail && Array.isArray(detail.order_inscrease)) this.$set(item, 'order_inscrease', detail.order_inscrease)
        } catch (error) {
          // 后台补取失败不影响列表，刷新列表时重试。
        }
      }
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.loading = true
      this.getOrder()
    },
    // 选择订单状态
    changeStatus (e) {
      console.log(e, this.search.status)
      this.statusId = e
      this.search.status = e
      this.loading = true
      this.getOrder(true)
    },
    // 选择服务类目
    changeClass (e) {
      console.log(e, this.search.class_id)
      this.search.class_id = e
    },
    // 选择服务类型
    changeType (e) {
      console.log(e, this.search.type_id)
      this.search.type_id = e
    },
    searchOrder () {
      this.loading = true
      this.getOrder(true)
    },
    refreshOrder () {
      this.loading = true
      this.getStatus()
      this.getOrder()
    },
    clear () {
      let vm = this
      vm.search = {
        status: '',
        worker_nickname: '',
        worker_phone: '',
        contacts: '',
        order_no: '',
        class_id: 0,
        type_id: 0
      }
      vm.statusId = '0'
      this.loading = true
      this.getOrder(true)
    },
    getStatus () {
      let vm = this
      vm.tabNav = []
      this.$request('62d91d0051fc2', {
        type: 1
      }).then(res => {
        res.data.data.forEach(function (item) {
          vm.tabNav.push({
            value: item.id,
            label: item.name,
            order_number: item.order_number
          })
        })
      })

      this.$request('6124d27dda9cc', {}).then(res => {
        vm.serviceList = []
        res.data.data.service_type.forEach(function (item) {
          vm.serviceList.push({
            value: item.id,
            label: item.name
          })
        })

        vm.service = []
        res.data.data.all_class.forEach(function (item) {
          if (item.parent_id == 0) {
            vm.service.push({
              value: item.id,
              label: item.name
            })
          }
        })
      })
    },
    normalizeRemarkList (res) {
      const data = res.data.data || []
      const list = Array.isArray(data) ? data : (data.list || data.data || data.rows || [])
      const total = Array.isArray(data) ? list.length : (data.total || data.count || data.listCount || data.list_count || list.length)
      return {
        total: Number(total) || list.length,
        list: list.map(item => {
          return {
            content: item.remark || item.remarks || item.content || item.note || item.text || '',
            color: item.color || item.flag_color || item.remark_color || '#ff4d4f',
            id: item.id,
            remark_id: item.remark_id,
            created_at: item.created_at,
            create_time: item.create_time,
            created_time: item.created_time,
            add_time: item.add_time,
            updated_at: item.updated_at,
            update_time: item.update_time
          }
        }).filter(item => item.content)
      }
    },
    getOrderRemark (order) {
      return this.$request(ORDER_REMARK_LIST_API, {
        order_id: order.id,
        page: 1
      }).then(res => {
        const remarkData = this.normalizeRemarkList(res)
        return Object.assign({}, order, {
          remark_list: remarkData.list,
          remark_count: remarkData.total,
          flag_color: remarkData.list[0] ? remarkData.list[0].color : (order.flag_color || order.remark_color || order.color || '')
        })
      }).catch(() => {
        return order
      })
    },
    mergeOrderRemark (order) {
      const cached = this.remarkCache[order.id]
      if (!cached) return order
      return Object.assign({}, order, {
        remark_list: cached.list,
        remark_count: cached.total,
        flag_color: cached.list[0] ? cached.list[0].color : (order.flag_color || order.remark_color || order.color || '')
      })
    },
    getRemarkCount (item) {
      if (!item) return 0
      return Number(item.tag_count || item.remark_count || item.remarks_count || item.order_remark_count || 0)
    },
    loadOrderRemarks (orders, requestKey) {
      orders.forEach(order => {
        this.getOrderRemark(order).then(orderWithRemark => {
          if (requestKey !== this.orderRequestKey) return
          const remarkData = {
            list: orderWithRemark.remark_list || [],
            total: orderWithRemark.remark_count || 0
          }
          this.$set(this.remarkCache, order.id, remarkData)
          const index = this.orderData.findIndex(item => item.id === order.id)
          if (index > -1) {
            this.$set(this.orderData, index, Object.assign({}, this.orderData[index], {
              remark_list: remarkData.list,
              remark_count: remarkData.total,
              flag_color: orderWithRemark.flag_color
            }))
          }
        })
      })
    },
    getOrder (resetPage = false) {
      let vm = this
      const requestKey = ++vm.orderRequestKey
      vm.loading = true
      vm.loadError = false
      vm.loadErrorMessage = ''
      console.log(vm.search, 'search')
      if (resetPage) {
        vm.tableShow.currentPage = 1
      }
      return this.$request('6182826d5d0aa', {
        page: vm.tableShow.currentPage,
        limit: vm.tableShow.pageSize,
        status: vm.search.status.toString(),
        class_id: vm.search.class_id, // 服务类目
        type_id: vm.search.type_id, // 服务类型
        worker_nickname: vm.search.worker_nickname,
        worker_phone: vm.search.worker_phone,
        contacts: vm.search.contacts,
        order_no: vm.search.order_no
        // start_time:vm.searFrom.start_time,
        // end_time:vm.searFrom.end_time
      }).then(res => {
        if (requestKey !== vm.orderRequestKey) return
        const orders = res.data.data || []
        if (!Array.isArray(orders)) throw new Error('订单列表数据格式异常')
        vm.tableShow.listCount = res.data.count
        vm.orderData = orders.map(order => vm.mergeOrderRemark(order))
        this.loading = false
        vm.loadOrderRemarks(orders, requestKey)
        vm.loadOrderDetails(orders, requestKey)
        // vm.tableData = res.data.data
        // vm.tableShow.listCount = res.data.count
      }).catch(error => {
        if (requestKey !== vm.orderRequestKey) return
        vm.loadError = true
        const status = error && error.response && error.response.status
        vm.loadErrorMessage = status ? `订单接口请求失败（HTTP ${status}）` : '订单加载失败'
      }).finally(() => {
        if (requestKey === vm.orderRequestKey) vm.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
  .order {
    padding: 10px;

    .status {
      // height: 40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .label {
        width: 70px;
        margin-right: 10px;
        color: rgb(17, 17, 17);
      }
    }

  }

  .refresh-btn {
    margin-right: 10px;
    margin-left: 0;
    display: inline-block;
    color: #111111;
    border: 1px solid #c4c6cf;
    border-radius: 500px;
    padding: 0 15px;
    font-size: 14px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    user-select: none;
  }

  .tabNav {
    //max-width: 600px;
    user-select: none;

    .tab-item {
      display: inline-block;
      margin-right: 8px;
      height: 35px;
      padding: 0 15px;
      cursor: pointer;
      background-color: #f7f8fa;
      border-radius: 9px;
      border: none;
      color: rgb(17, 17, 17);
      font-size: 12px;
      line-height: 35px;
    }

    .active {
      color: #FB9E2F;
      font-weight: 500;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border: 1px solid #FB9E2F;
        border-radius: 9px;
      }
    }
  }
</style>
